var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":"update-recipe-modal"},on:{"ok":_vm.submit}},[_c('b-form-textarea',{attrs:{"id":"textarea-default","rows":"6","value":_vm.description},on:{"input":value => _vm.input(value)}}),_c('div',{staticClass:"text-end"},[_vm._v(" -- Author "+_vm._s(_vm.author)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }